import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import {
    Metamodel,
    ModelConstants,
    SqlAnalyticsEndpointCopySource
} from 'shell-models-lib';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
export type LakeHouseTableActionType = 'Append' | 'Overwrite';

export const sqlAnalyticsEndpointMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.sqlAnalyticsEndpoint.linkedServiceType,
        displayName: stringResources.SQL_Analytics_Endpoint_DisplayText,
        supportedInTrident: true,
        fabricArtifactType: ModelConstants.sqlAnalyticsEndpointArtifactType,
        linkedServiceKind: 'table',
        icon: {
            className: 'svg-i_dataWarehouse'
        },
        dmtsCredentialConnectionType: adfModelTypeMap.sqlAnalyticsEndpointCredential.linkedServiceType,
        isFirstClass: true,
        supportDatasetV2: true,
        category: ['Workspace'],

        copySinkTypes: [],
        copySourceTypes: [Metamodel.modelFor(SqlAnalyticsEndpointCopySource).name],

        controls: []
    };

    return metadata;
};
